<template>
  <div class="booking-view-container" :class="{'lister-branding': !isHirer}">
    <div class="back-btn button-slide-hover" @click="returnToDashboard">
      <svg xmlns="http://www.w3.org/2000/svg">
        <image xlink:href="/images/icons/chevron-left.svg" />
      </svg>
      BACK
    </div>
    <div class="booking-label" :class="booking.type+'-type'">{{ booking.booking_type_label }}</div>
    <div class="booking-view-content-grid">
      <div class="booking-view-content-left">
        <div class="booking-view-title interactive" @click="goToListing(booking)">{{ booking.listing.space_name }}</div>
        <div class="booking-info-container">
          <div class="quote-container" v-if="booking.type === 'booking' && isHirer">
            <div class="booking-info-label">Current Quote</div>
            <div class="booking-info-value" v-if="booking.current_quote_for_user && booking.current_quote_for_user.grand_total_formatted !== null">{{ booking.current_quote_for_user.grand_total_formatted }} (inc GST)</div>
            <div class="booking-info-value" v-else>TBC</div>
          </div>
          <div class="quote-container" v-else-if="isLister && booking.current_quote_total_formatted">
            <div class="booking-info-label">Payment to You</div>
            <div class="booking-info-value">
              {{ booking.current_quote_total_formatted }}
            </div>
          </div>
          <div class="booking-type-date-container">
            <div class="booking-info-label">{{ booking.type === 'recce' ? 'Recce' : 'Production' }} Date</div>
            <div class="booking-info-value">
              <template v-if="booking.from !== booking.to">
                {{ formatDate(booking.from, 'D MMM YYYY') }} - {{ formatDate(booking.to, 'D MMM YYYY') }}
              </template>
              <template v-else>
                {{ formatDate(booking.from, 'D MMM YYYY') }}
              </template>
            </div>
          </div>
          <div class="booking-time-container">
            <template v-if="booking.type === 'recce' && booking.call_times_arrivals.length">
              <div class="booking-info-label">{{ booking.type === 'recce' ? 'Recce' : 'Production' }} Time</div>
              <div class="booking-info-value">
                {{ booking.type === 'recce' ? booking.call_times_arrivals[0].toUpperCase() : formatTime(booking.call_times_arrivals[0], 'h:mma') }}
              </div>
            </template>
          </div>
        </div>
        <p class="booking-info-label mb-4" v-if="booking.type === 'booking' && booking.sub_total_formatted === null">
          Our team will review your booking and confirm the price shortly
        </p>
        <div class="booking-view-label mt-4">
          Production Dates
        </div>
        <div v-for="(date, index) in booking.days_and_times_formatted" class="booking-view-day-container">
          <div class="booking-date-day">
            Day {{ date.dayNumber }}
          </div>
          <div class="booking-date-full">{{ date.dateLong }}</div>
          <div class="booking-date-container">
            <div class="">
              <div class="booking-view-day-label">
                {{ booking.type === 'recce' ? 'Arrival time' : 'Call time' }}
              </div>
              <div class="booking-view-day-value">
                {{ date.time }}
              </div>
            </div>
            <div v-if="booking.status === 'accepted' || booking.status === 'completed'">
              <div class="booking-view-day-label">
                Address
              </div>
              <div class="booking-view-day-value">
                {{booking.listing.address.full_label}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="booking-view-content-right">
        <div class="booking-view-listing-container">
          <div class="booking-listing-image">
            <img
              :src="
                booking.listing.preferred_thumbnail
                  ? booking.listing.preferred_thumbnail.url
                  : booking.listing.thumbnail_url
              "
              class="cover"
              :alt="booking.listing.space_name"
            />
          </div>
          <div class="booking-listing-info">
            <div class="booking-listing-title">{{ booking.listing.space_name }}</div>
            <div class="booking-listing-address">{{ booking.listing.address_label }}</div>
            <div class="booking-view-listing interactive" @click="goToListing(booking)">View Listing</div>
            <!-- <div class="booking-view-listing interactive button-slide-hover ml-4" v-if="booking.current_quote_for_user" @click="openShareModal(booking)">Share</div> -->
          </div>
        </div>
        <div class="booking-view-status-container">
          <div class="accordion-like accordion-element" :class="{'active': showStatusLog}" @click="showStatusLog = !showStatusLog">
            <div class="booking-accordion-container booking-view-label">
              <div>Status Log</div>
              <div class="booking-accordion-icon"><svg-icon id="selectCaret" /></div>
            </div>
            <div class="content status-log-content" @click.stop>
              <div class="status-log-block" v-for="(status, index) in booking.status_log">
                <div class="status-log-block-left">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <image xlink:href="/images/icons/ellipse-green.svg" v-if="index == 0"/>
                    <image xlink:href="/images/icons/ellipse-grey.svg" v-else />
                  </svg>
                  <div class="booking-status-name">{{ status.label }}</div>
                  <div>&nbsp;</div>
                  <div class="booking-reason">{{ status.reason }}</div>
                </div>
                <div class="status-log-block-right">
                  <div v-if="index > 0">
                    <div class="badge">Completed</div>
                    <div class="booking-date">{{ status.date }}</div>
                  </div>
                  <template v-if="status.pending_action && status.pending_action.actions && status.pending_action.actions.length && !publicView">
                    <div>
                      <div
                        v-for="option in status.pending_action.actions"
                        v-if="option.action"
                        class="booking-status-action badge interactive"
                        :class="[option.class]"
                        @click="doAction(option.action, booking)">
                        {{ option.label }}
                      </div>
                      <div class="booking-date">{{ status.date }}</div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="fees-container" v-if="booking.type === 'booking' && booking.has_cost && isHirer">
          <div class="booking-view-label">Fees and charges</div>
          <div class="fees-content">
            <div v-for="item in booking.current_quote_for_user.user_line_items" class="fee-item">
              <div class="fee-label">{{ item.label }}<span v-if="item.description"> - {{ item.description }}</span></div>
              <div class="fee-value">${{ item.total_formatted }}</div>
            </div>
            <div v-if="booking.fee_breakdown" class="fee-item">
              <div class="fee-label">{{ booking.fee_breakdown }}</div>
            </div>
          </div>
          <div class="fees-footer">
            <div class="fees-total-label">Sub Total</div>
            <div class="fees-total-value">${{ booking.current_quote_for_user.sub_total_formatted }}</div>
          </div>
          <div class="fees-footer">
            <div class="fees-total-label">GST</div>
            <div class="fees-total-value">${{ booking.current_quote_for_user.gst_total_formatted }}</div>
          </div>
          <div class="fees-footer">
            <div class="fees-total-label">Total</div>
            <div class="fees-total-value">${{ booking.current_quote_for_user.grand_total_formatted }}</div>
          </div>
        </div>
        <div class="terms-container" v-if="booking.has_cost && isHirer">
          <div class="terms-label">Terms</div>
          <div class="terms-content">
            <template v-if="booking.type === 'recce'">
              100% payment required at the time of booking.
            </template>
            <template v-else>
              Please see the <a href="/terms-and-conditions/hirer" class="fg-brand-blue" @click.stop.prevent="showHirerTermsModal">Hirer Terms &amp; Conditions</a> for information on fees and cancellations.
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showStatusLog: false
    }
  },
  methods: {
    returnToDashboard() {
      this.$store.commit('findspace/setSubpage', { subpage: 'home', item: null })
    },
    goToListing(booking) {
      window.open(booking.listing.listing_url, '_blank')
    },
    formatDate (src, format) {
      return dayjs(src).format(format)
    },
    formatTime (src, format) {
      return dayjs(src, 'HH:mm:ss').format(format)
    },
    getFullBookingName (booking) {
      return `${booking.booking_type_label} <span class="fg-primary">${booking.listing.space_name}</span>`
    },
    openShareModal(booking) {
      this.$store
        .dispatch("modals/show", {
          type: "booking-share",
          maskCanDismiss: false,
          headless: true,
          narrow: true,
          data: {
            booking: booking
          }
        });
    },
    doAction (action, booking) {
      switch (action) {
        case 'review_and_pay':
          const title = booking.is_payable && booking.has_cost ? 'Review &amp; Pay' : 'Review'
          this.$store.dispatch('modals/show', {
            title: `${this.getFullBookingName(booking)} - ${title}`,
            type: 'booking-quote-review',
            data: booking
          })
            .then(() => {})
            .catch(() => {})
          break

        case 'pay':
          const payTitle = booking.is_payable && booking.has_cost ? 'Pay' : 'Review'
          this.$store.dispatch('modals/show', {
            title: `${this.getFullBookingName(booking)} - ${payTitle}`,
            type: 'hirer-quote-pay',
            data: booking
          })
            .then(() => {})
            .catch(() => {})
          break

        case 'review':
          const reviewTitle = booking.is_payable && booking.has_cost ? 'Review &amp; Pay' : 'Contact Admin'
          this.$store.dispatch('modals/show', {
            title: `${this.getFullBookingName(booking)} - ${reviewTitle}`,
            type: 'hirer-quote-confirm',
            data: booking
          })
            .then(() => {})
            .catch(() => {})
          break

        case 'view_quote':
          this.$store.dispatch('modals/show', {
            title: `${this.getFullBookingName(booking)} - Payout`,
            type: 'booking-lister-quote',
            data: booking
          })
            .then(() => {})
            .catch(() => {})
          break

        case 'view_detailed_quote':
          this.$store.dispatch('modals/show', {
            title: `${this.getFullBookingName(booking)} - Quote`,
            type: 'booking-hirer-quote-view',
            data: booking
          })
            .then(() => {})
            .catch(() => {})
          break

        case 'feedback':
          this.$store.dispatch('modals/show', {
            title: `Amend Booking for ${this.getFullBookingName(booking)}`,
            type: 'booking-feedback',
            data: booking
          })
            .then(() => {})
            .catch(() => {})
          break

        case 'confirm':
          if (!this.$store.getters['user/stripeConnectIsOnboarded'])
          {
            this.$store.dispatch('modals/show', {
              title: `Let's setup your payment details!`,
              type: 'first-payment-setup',
              data: booking
            })
              .then(() => {})
              .catch(() => {})
            break
          }

          this.$store.dispatch('modals/show', {
            title: `Confirm ${this.getFullBookingName(booking)}`,
            type: 'booking-confirm',
            data: booking
          })
            .then(() => {})
            .catch(() => {})
          break

        case 'approve_by_lister':
          if (!this.$store.getters['user/stripeConnectIsOnboarded'])
          {
            this.$store.dispatch('modals/show', {
              title: `Let's setup your payment details!`,
              type: 'first-payment-setup',
              data: booking
            })
              .then(() => {})
              .catch(() => {})
            break
          }

          this.$store.dispatch('modals/show', {
            title: `Confirm ${this.getFullBookingName(booking)}`,
            type: 'lister-quote-confirm',
            data: booking
          })
            .then(() => {})
            .catch(() => {})
          break

        case 'decline':
          this.$store.dispatch('modals/show', {
            title: `Decline ${this.getFullBookingName(booking)}`,
            type: 'booking-decline',
            data: booking
          })
            .then(() => {})
            .catch(() => {})
          break

        case 'download_schedule':
          if (!booking.booking_schedule_url) {
            return this.$store.dispatch('modals/show', {
              title: `${booking.booking_type_label} schedule & location`,
              type: 'booking-schedule-unavailable',
              data: booking
            })
              .then(() => {})
              .catch(() => {})
          }
          window.location.href = `${booking.booking_schedule_url}?token=${this.$store.getters['user/accessToken']}`
          break
      }
    },
    showHirerTermsModal () {
      window.open("/pdf/hirer-agreement.pdf", '_blank');
    },
  },
  computed: {
    booking() {
      return this.$store.getters['findspace/item'];
    },
    publicView() {
      return this.$store.getters['findspace/public']
    },
    isHirer () {
      return this.$store.getters['user/isHirer']
    },
    isLister () {
      return this.$store.getters['user/isLister']
    },
  }
}
</script>
